import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';

import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { EventManagerService } from './pages/general/blog/event-manager.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { SharedCommonModule } from './common/shared.module';
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import {
  NgbModal,
  NgbModalModule,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { ConfirmRouterPopupComponent } from './common/components/confirm-router-popup/confirm-router-popup.component';
import { StateService } from './extend-code/state.service';
import { WhatIsOpenEndFundComponent } from './pages/general/dashboard/what-is-open-end-fund/what-is-open-end-fund.component';
import { AppService } from './app.service';
import { DetailFundPopupComponent } from './pages/general/product/components/detail-fund-popup/detail-fund-popup';
import { DateUtil } from './common/utils/date.util';
import { REGEX_LINK_BOLD_1 } from './pages/general/dashboard/gold-questions/parse-content/key';
import { environment } from '../environments/environment';

declare let $: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterOutlet,
    HttpClientModule,
    SharedCommonModule,
    TranslateModule,
    NgbModalModule,
  ],
  providers: [TranslateService, TranslateStore],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit, AfterViewChecked {
  categories: any[] = [];
  language: string = '';
  isDevice: boolean = false;
  public eventSubscribers?: Subscription[] = [];
  constructor(
    private eventManager: EventManagerService,
    private translate: TranslateService,
    private appService: AppService,
    public route: ActivatedRoute,
    public router: Router,
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
    }
    if (typeof window === 'undefined') {
      return;
    }

    this.eventManager.subscribe('open-fund-popup', (res: any) => {
      this.detailProductByCode(res.content.productCode);
    });
    this.route.queryParams.subscribe((params: any) => {
      if (typeof window === 'undefined') {
        return;
      }
      if (params.utm_source === 'accesstrade' && params.aff_sid) {
        localStorage.setItem('utm_source', params.utm_source);
        localStorage.setItem('aff_sid', params.aff_sid);
      }
      if (params['thirdAppId']) {
        localStorage.setItem('thirdAppId', params['thirdAppId']);
        localStorage.setItem('referralCode', '');
        localStorage.setItem('agencyPartnerCode', '');
      }
      if (params['language'] || params['lang']) {
        const language = params['language'] || params['lang'];
        this.saveLanguage(language === 'EN' || language === 'en' ? 'en' : 'vi');
      }
    });

    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //       if (window.scrollY > 500) {
    //         const backToTop: any = document.getElementById('back-to-top');
    //         backToTop && backToTop.click();
    //       }
    //   }

    //   if (event instanceof NavigationEnd) {
    //   }

    //   if (event instanceof NavigationError) {
    //       console.log(event.error);
    //   }
    // });
    this.eventSubscribers = [
      this.eventManager.subscribe('change-language', (res: any) => {
        this.saveLanguage(res.content.language);
      }),
      this.eventManager.subscribe('confirm-router-change', (res: any) => {
        localStorage.setItem('nextURL', res.content.url);
        this.openConfirmRouterPopupComponent(res.content.func);
      }),
      this.eventManager.subscribe(
        'show-confirm-vietnamese-content',
        (res: any) => {
          const language = localStorage.getItem('language') || '';
          if (
            typeof window === 'undefined' ||
            language.toLowerCase() === 'vi'
          ) {
            return;
          }
          this.eventManager.broadcast({
            name: 'confirm-router-change',
            content: {
              func: res.content.func,
              url: res.content.url,
            },
          });
        }
      ),
      this.eventManager.subscribe('what-is-open-end-fund', (res: any) => {
        this.openWhatIsOpenEndFundPopup();
      }),
    ];
    this.getFunds();
  }
  ngAfterViewInit(): void {
    if (typeof window === 'undefined') {
      return;
    }
    this.isDevice = $(window).width() < 480 ? true : false;
    $('body').on('click', (e: any) => {
      this.eventManager.broadcast({
        name: 'body-click',
        content: {
          event: e,
        },
      });
    });
    this.language = localStorage.getItem('language') || 'vi';
    this.saveLanguage(this.language);
  }
  ngAfterViewChecked(): void {
    if (typeof window === 'undefined') {
      return;
    }
  }
  saveLanguage(language: any) {
    this.language = (language || 'VI').toLowerCase();
    this.translate.use(this.language);
    if (typeof window !== 'undefined') {
      localStorage.setItem('language', this.language);
      StateService.changeLanguage(this.language);
      const file = this.language === 'vi' ? 'vi_VN' : 'en_US';
      localStorage.setItem('language-file', file);
    }
  }
  openConfirmRouterPopupComponent(func?: any) {
    const options: NgbModalOptions = {};
    options.centered = true;
    options.windowClass = 'confirm-router-modal';
    const modalRef = this.modalService.open(
      ConfirmRouterPopupComponent,
      options
    );
    modalRef.componentInstance.func = func;
  }
  openWhatIsOpenEndFundPopup() {
    const options: NgbModalOptions = {};
    options.centered = true;
    options.windowClass = 'what-is-open-end-fund-modal';
    const modalRef = this.modalService.open(
      WhatIsOpenEndFundComponent,
      options
    );
  }
  detailProductByCode(productCode: any) {
    return this.appService
      .getProductByCode(productCode)
      .subscribe((result: any) => {
        const options: NgbModalOptions = {};
        options.centered = true;
        options.windowClass = 'modal-lg fund-popup';
        const modalRef = this.modalService.open(
          DetailFundPopupComponent,
          options
        );
        modalRef.componentInstance.product = result.data;
      });
  }
  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  getFunds() {
    let requestBody: any = {
      types: ['NEW_FUND', 'TRADING_FUND'],
      page: 1,
      pageSize: 10,
      sortField: "navTo6Months",
      sortOrder: "DESC",
      fundAssetTypes: [],
    };
    return this.appService.getProducts(requestBody).subscribe(
      (res: any) => {
        if (!res.data) {
          return;
        }
        const result = res.data;
        const products = (result.rows || []).map((item: any) => {
          return {
            shortName: item.shortName,
            url: `${environment.domain}/quy/${item.shortName}`,
            currentNAV: (item.extra || {}).currentNAV || 0,
            interestRate: (item.productNavChange || {}).navTo6Months,
            description: item.description,
            ownerAvatarUrl: (item.owner || {}).avatarUrl,
            ownerName: (item.owner || {}).name,
          };
        });
        this.setMainEntity(products);
      },
      (err: any) => {
      }
    );
  }
  setMainEntity(products: any[]) {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'header-schema';
    script.textContent = `
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Giá chứng chỉ quỹ hôm nay ngày ${DateUtil.parseDate(new Date(), 'yyyy-MM-dd')}",
        "description": "Giá 10 chứng chỉ quỹ có tăng trưởng 6 tháng cao nhất",
        "url": "${environment.domain}",
        "dateModified": "${DateUtil.parseDate(new Date(), 'yyyy-MM-ddThh:mm')}",
        "mainEntity": {
            "@type": "ItemList",
            "name": "Giá chứng chỉ quỹ hôm nay",
            "numberOfItems": 10,
            "itemListElement": [
              ${
                products.map((product) => {
                  return `
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "item": {
                      "@type": "InvestmentFund",
                      "name": "${product.shortName}",
                      "url": "${product.url}",
                      "image": "${product.ownerAvatarUrl}",
                      "logo": "${product.ownerAvatarUrl}",
                      "description": "${product.description}",
                      "amount": {
                        "currency": "VND",
                        "value": "${product.currentNAV}"
                      },
                      "interestRate": "${product.interestRate}",
                      "owner": {
                        "name": "${product.ownerName}"
                      }
                    }
                  }`;
                }).join(',')
              }
                
            ]
        }
      } 
    `;
    document.body.appendChild(script);
  }
}
